if (!customElements.get('product-delivery-time')) {
	class ProductDeliveryTime extends HTMLElement {
		connectedCallback() {
			this.availableEl = this.querySelector('[delivery-time-available]');
			this.soldOutEl = this.querySelector('[delivery-time-sold-out]');
			this.updateDeliveryTimeListener = this.updateDeliveryTime.bind(this);
			document.addEventListener('on:variant:change', this.updateDeliveryTimeListener);
		}
		disconnectedCallback() {
			document.removeEventListener('on:variant:change', this.updateDeliveryTimeListener);
		}
		get productID() {
			return parseInt(this.dataset.productId);
		}
		get isUpdateDisabled() {
			return this.dataset.updateDisabled;
		}
		updateDeliveryTime(event) {
			if (this.isUpdateDisabled || event.detail.product.id !== this.productID) return;
			const isAvailable = event?.detail?.variant?.available;
			this.availableEl?.toggleAttribute('hidden', !isAvailable);
			this.soldOutEl?.toggleAttribute('hidden', isAvailable);
		}
	}
	customElements.define('product-delivery-time', ProductDeliveryTime);
}
